module.exports = __webpack_public_path__ + "assets/img/function3.6d1fd021.png";